import { Fragment } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import FormOne from "./FormOne";
import FormTwo from "./FormTwo";
import { ComponentHeader, PageHeader, Paper } from "../../../components";
import { ActiveTextEighteen, colors } from "../../css components/Style";
import { CancelButton } from "../../css components/Button";

export default function FormDisplay({ formData, noDetails }) {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Grid item xs={12}>
        <PageHeader
          pageName={"Company Details"}
          pageHeader={formData.companyName}
          buttons={[
            <CancelButton variant="outlined" onClick={() => navigate(-1)}>
              Back
            </CancelButton>,
          ]}
        />
      </Grid>

      {noDetails && (
        <Paper>
          <Grid item xs={12} alignSelf={"center"}>
            <ActiveTextEighteen color={colors.error}>
              Brand hasn't registered it's company yet.
            </ActiveTextEighteen>
          </Grid>
        </Paper>
      )}

      <Grid item xs={12}>
        <Paper gridSpacing={4}>
          <Grid item xs={12}>
            <ComponentHeader title={"Company Details"} />
          </Grid>

          <FormOne formData={formData} />

          <FormTwo formData={formData} />
        </Paper>
      </Grid>
    </Fragment>
  );
}
